<script setup lang="ts">

import { usePresentation } from '@presentation/Types';
import IntroductionPageOptions from '@presentation/Components/IntroductionPageOptions.vue';

const presentation = usePresentation();

</script>

<template>

    <div class="flex flex-col min-h-full grow items-center justify-center gap-8">
        
        <Image src="/cv-logo.png" class="h-32 2xl:h-48" />

        <h1 class="text-2xl md:text-3xl lg:text-4xl font-semibold uppercase opacity-30 text-center">
            Global Reseller Presentation
        </h1>

        <IntroductionPageOptions />

        <button 
            @click.stop="() => presentation.goto( presentation.sections[ 1 ].name )"
            class="bg-primary-500 hover:bg-primary-600 text-white rounded-md p-4 shadow tracking-wider font-semibold uppercase mt-4 transition duration-100">
            Start Presentation
        </button>


        <a href="https://connectedvehicles.com.au" class="absolute bottom-4 opacity-50">www.connectedvehicles.global</a>

    </div>

</template>